/* global process:readonly */
import axiosPackage from 'axios';


const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl || !apiUrl.trim()) {
    throw new Error('REACT_APP_API_URL is required. Set it in an environment file or the shell, then restart or rebuild the app.');
}

const axios = axiosPackage.create({
    baseURL: apiUrl,
    headers: {},
    validateStatus: () => true
});

const post = (path, info, callback, config) =>
    axios.post(path, info, config)
        .then(response => callback(response.status < 200 || response.status >= 300, response.data))
        .catch(e => { console.error(e); callback(true, { message: 'An unexpected error occurred. Please try again or contact support.' }); });

export { post };
